import { useState } from 'react';
import { summarizeOverloadOptions } from '../../personal-nikke/domain/personalNikke.js';
import { PersonalNikkeOverload } from '../../personal-nikke/shared/PersonalNikkeOverload.jsx';
import { RaidPracticeNikkeCard } from './RaidPracticeNikkeCard.jsx';

export function RaidPracticeNikkeResultCard({
  item,
  personal = null,
  selectedIndex = -1,
  onSelect = () => {},
}) {
  const [overloadOpen, setOverloadOpen] = useState(false);
  const hasOverload = summarizeOverloadOptions(personal?.equipment).length > 0;
  const selected = selectedIndex >= 0;

  return (
    <article className={`raid-practice-nikke-result-card ${selected ? 'active' : ''} ${hasOverload ? 'has-overload' : ''} ${overloadOpen ? 'overload-open' : ''}`.trim()}>
      <button
        type="button"
        className="raid-practice-nikke-result-select"
        aria-pressed={selected}
        aria-label={`${item?.name || '니케'} 선택`}
        onClick={() => {
          setOverloadOpen(false);
          onSelect(item);
        }}
      >
        <RaidPracticeNikkeCard item={item} personal={personal} showPersonalOverload={false} />
      </button>

      {hasOverload ? (
        <button
          type="button"
          className={`raid-practice-nikke-overload-toggle ${overloadOpen ? 'active' : ''}`.trim()}
          aria-expanded={overloadOpen}
          aria-label={`${item?.name || '니케'} 오버로드 ${overloadOpen ? '닫기' : '표시'}`}
          title={overloadOpen ? '오버로드 닫기' : '오버로드 표시'}
          onClick={() => setOverloadOpen((current) => !current)}
        >
          {overloadOpen ? '×' : 'OL'}
        </button>
      ) : null}

      {selected ? <em className="raid-practice-nikke-selected-slot">S{selectedIndex + 1}</em> : null}
      {hasOverload ? <PersonalNikkeOverload personal={personal} /> : null}
    </article>
  );
}
